import { render, staticRenderFns } from "./view-items.vue?vue&type=template&id=503ba557"
import script from "./view-items.vue?vue&type=script&lang=js"
export * from "./view-items.vue?vue&type=script&lang=js"
import style0 from "./view-items.vue?vue&type=style&index=0&id=503ba557&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports